export default "__VITE_PUBLIC_ASSET__e53bb27e__"